import { render, staticRenderFns } from "./OrderStatusConfirmIcon.vue?vue&type=template&id=6efb8827&scoped=true&"
import script from "./OrderStatusConfirmIcon.vue?vue&type=script&lang=js&"
export * from "./OrderStatusConfirmIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efb8827",
  null
  
)

export default component.exports